import { IApiError } from '@/models/apiError.model';
import {
  IProduct,
  IProductRegionsAndPricesListItem,
  IProductVariation,
  IStoreItem,
  ITopProduct,
} from '@/models/products.model';
import { IPagination } from '@/models/pagination.model';
import { TGetProductsQuery, TGetProductsOfMonthQuery } from '../helpers';

export const PRODUCTS_SLICE_NAME = 'products';

export interface ProductsState {
  productsList: {
    data: IProduct[];
    meta: IPagination;
  } | null;
  productsOfMonthList: {
    data: IProduct[];
    meta: IPagination;
  } | null;
  topProductsList: ITopProduct[] | null;
  product: IProduct | null;
  storeList: IStoreItem[] | null;
  productsOfMonth: IProduct | null;
  productVariations: IProductVariation[] | null;
  productRegionsAndPrices: IProductRegionsAndPricesListItem[] | null;
  isLoading: boolean;
  query: TGetProductsQuery | null;
  productsOfMonthQuery: TGetProductsOfMonthQuery | null;
  error: IApiError | null;
  isPublishValidationError: boolean;
}

export const initialState: ProductsState = {
  productsList: null,
  storeList: null,
  productsOfMonthList: null,
  topProductsList: null,
  product: null,
  productsOfMonth: null,
  productVariations: null,
  productRegionsAndPrices: null,
  isLoading: false,
  query: null,
  productsOfMonthQuery: null,
  error: null,
  isPublishValidationError: false,
};
